/**
 * Shared Tailwind class string for the small, slate-bordered action buttons
 * used across the build header and toolbar (e.g. Cancel, Retry failures,
 * Pipeline settings, list view empty state actions).
 *
 * Compose with additional classes via `classNames(buildActionButtonClassName, ...)`
 * for variants such as icon-only padding, danger text colour, or rounded
 * corner adjustments when joining buttons together.
 */
export const buildActionButtonClassName =
  "btn-small shadow-xs rounded-sm border border-slate-400 font-medium transition-all hover:border-slate-500 hover:bg-gray-100 active:bg-gray-300 active:shadow-inner";
